import JobExperienceIcon from "../../assets/job_experience_icon.png";
import BadgeIcon from "../../assets/badge_icon.png";
import SkillSetIcon from "../../assets/skill_set_icon.png";
import moment from "moment";
import { useEffect, useState } from "react";

const Summary = ({ carepro, skills, achievements }) => {
    const [totalWorkYears, setTotalWorkYears] = useState("");

    const calculateTotalWorkYears = () => {
        const workExp = carepro.work_experience;
        let workFrom;
        let workTo;
        let totalWorkPeriodMonth;
        let sum = 0;
        
        for (let i = 0; i < workExp.length; i ++){
            workFrom = moment(workExp[i].work_from).utc().format("MMM YYYY");
            workTo = workExp[i].work_to? moment(workExp[i].work_to).utc().format("MMM YYYY") : moment(Date()).utc().format("MMM YYYY");
            totalWorkPeriodMonth = moment(workTo).diff(moment(workFrom), 'months');
            sum += totalWorkPeriodMonth;
        }

        const totalWorkPeriod = sum / 12 < 0? `${sum} month(s)`: `${parseInt(sum / 12)} year(s), ${sum % 12} month(s)`;
        

        return totalWorkPeriod;
    }
    
    const skillLength = skills.length;
    const achievementLength = achievements.length;

    useEffect(() => {
        const total = calculateTotalWorkYears();
        setTotalWorkYears(total);
    }, [])

    return (
        <div className="summary">
            {
                carepro.work_experience.length === 0?
                <div></div> :
                <div className="card">
                    <div className="column details">
                        <img className="icon" alt="Job Experience" src={ JobExperienceIcon } />
                        <div className="icon-details-container">
                            <span className="icon-header">{`${totalWorkYears} job`}</span>
                            <span className="icon-text">Experiences</span>
                        </div>
                    </div>
                </div>
            }
            

            {
                achievements.length === 0?
                <div></div> : 
                <div className="card">
                    <div className="column details">
                        <img className="icon" alt="Badges" src={ BadgeIcon } />
                        <div className="icon-details-container">
                            <span className="icon-header">{`${achievementLength} badges`}</span>
                            <span className="icon-text">Achievement</span>
                        </div>
                    </div>
                </div>
            }

{
                skills.length === 0?
                <div></div> :
                <div className="card">
                    <div className="column details">
                        <img className="icon" alt="Skills" src={ SkillSetIcon } />
                        <div className="icon-details-container">
                            <span className="icon-header">{`${skillLength} skills`}</span>
                            <span className="icon-text">Own</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Summary;